import React from "react";
import "../../InvoiceModal.css";
import { useTranslation } from "react-i18next";

const Tracking = ({ data }) => {
  const { t } = useTranslation("finances");
  return (
    <>
      <div className="invmodal__shipment_details_wrap">
        <div className="invmodal__shipment_detailshding">
          {t("invoice.tracking.title")}
        </div>
        <div className="invmodal__shshiptracking_grid">
          <div className="invmodal__shdetails_gridhd">
            {t("invoice.tracking.status")}
          </div>
          <div className="invmodal__shdetails_gridhd">
            {t("invoice.tracking.date")}
          </div>
          <div className="invmodal__shdetails_gridhd">
            {t("invoice.tracking.time")}
          </div>
          <div className="invmodal__shdetails_gridhd">
            {t("invoice.tracking.location")}
          </div>
          {data?.shipment_histories?.map((history) => {
            return (
              <>
                <div className="invmodal__shdetails_griditem">
                  {history?.ShipmentStatus ?? "-"}
                </div>
                <div className="invmodal__shdetails_griditem">
                  {history?.StatusDate?.slice(0, 10) ?? "-"}
                </div>
                <div className="invmodal__shdetails_griditem">
                  {" "}
                  {history?.StatusDate?.slice(11, 16) ?? "-"}
                </div>
                <div className="invmodal__shdetails_griditem">
                  {" "}
                  {history?.LastLocation ?? "-"}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Tracking;
